import React, { useContext, useState } from "react";
import style from "./CategoryCard.module.css";
import { AppContext } from "../../../../AppContext";

import { motion } from "framer-motion";
import icons from "../../../../icons";


const compareDates = (firstDate, secondDate, strict=false) => {
    if (!firstDate || !secondDate) 
        return false;

    if (strict)
        return firstDate.getTime() === secondDate.getTime();
    
    return firstDate.getDate() === secondDate.getDate() && firstDate.getMonth() === secondDate.getMonth() && firstDate.getFullYear() === secondDate.getFullYear();
};

const getProgress = category => Math.round(Object.values(category.flashCards).filter(card => card.box === 3).length / Object.keys(category.flashCards).length * 100);
const getCurrentProgress = category => Math.round(Object.values(category.flashCards).filter(card => isCardForToday(card) || compareDates(new Date(card.lastDone), new Date())).length / Object.values(category.flashCards).filter(card => compareDates(new Date(card.lastDone), new Date())).length * 100);
const isCardForToday = ({ lastDone, box }) => 
    (box === 1 && new Date().getTime() - new Date(lastDone).getTime() >= 1000 * 60 * 24) || 
    (box === 2 && new Date().getTime() - new Date(lastDone).getTime() >= 1000 * 60 * 24 * 2) || 
    (box === 3 && new Date().getTime() - new Date(lastDone).getTime() >= 1000 * 60 * 24 * 3);

const CategoryCard = props => {
    const { subjects, updateFlashCards } = useContext(AppContext);

    const [currentProgress, setCurrentProgress] = useState(getCurrentProgress(props.category) !== Infinity ? getCurrentProgress(props.category) : 0);
    const [progress, setProgress] = useState(getProgress(props.category));

    const getSubjectIcon = subjectName => {
        let returnIcon = "question_mark_orange_icon";
    
        if (subjects)
            Object.values(subjects).forEach(subject => {
                if (subject.subject?.toLowerCase() === subjectName?.toLowerCase()) returnIcon = subject.icon;
            });
    
        return returnIcon;
    };

    return <main 
        className={ style.main }
        transition={{ duration: .1 }}
        initial={{ width: "90%", marginLeft: "1rem" }}
        style={{ 
            "--barProgress": `${isNaN(progress) ? 0 : progress}%`, 
            "--barBorders": progress === 100 ? "2rem" : "2rem 0 0 2rem",
            "--boxShadowsTop": props.selected ? "2.5rem" : ".6rem",
            "--boxShadowsLeft": props.selected ? ".75rem" : ".6rem",
            boxShadow: props.selected && ".4rem 1.25rem rgb(38, 37, 37)",
            transform: props.selected ? "translate(0%, -10%)" : props.last ?  "translate(-13vw, 0)" : null,
            marginLeft: "1rem", 
            width: "90%", 
            background: "rgb(58, 57, 57)",
        }}>
            <div className={ style.categoryCard } style={{ overflow: "hidden" }} >
                <div className={ style.flex }>
                    <img src={ icons[getSubjectIcon(props.category.subject)] } style={{ width: "1.5rem", marginLeft: "1rem", marginRight: "1rem" }}></img>
                    <h2 style={{ fontSize: ".9rem", flex: "1" }}>{ props.category.subject }</h2>
                    <div className={ style.flex } style={{ background: "var(--orange)", borderRadius: "1rem", marginRight: "1rem", padding: ".25rem .75rem", height: "fit-content", marginTop: ".5rem", opacity: props.selected ? "1" : "0", transition: "opacity 1s ease" }}>
                        <h3 style={{ fontSize: ".8rem", marginTop: "auto", marginBottom: "auto" }} onClick={ props.activate }>AVVIA</h3>
                        <img src={ icons.arrow_right_icon } style={{ width: "1.5rem", height: "1.5rem", marginLeft: ".25rem", marginTop: "auto", marginBottom: "auto" }}></img>
                    </div>
                </div>
                <h1 style={{ textAlign: "center", fontSize: "1rem", marginTop: "2rem", marginBottom: "1.5rem", marginLeft: "2rem", marginRight: "2rem", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>{ props.category.name }</h1>
                <div className={ style.progressBar } style={{ marginBottom: props.selected && "1rem" }}></div>
                <h3 style={{ fontSize: ".8rem", textAlign: "center", marginBottom: props.selected ? "1rem" : ".5rem", marginTop: "1rem", transition: "all .5s ease" }}><span style={{ color: "var(--orange)" }}>{ Object.values(props.category.flashCards).filter(card => card.box === 3).length }/{ Object.values(props.category.flashCards).length }</span> nell'ultima scatola</h3>
            </div>
        </main>
};

export default CategoryCard;